export default __webpack_public_path__ + "static/Hero_09_Markets-78ebce2253a970494d123fa9e3326026.jpg";